export const localStorageKey = 'srp-ss-nudge-modal';
